import StorageManager from "../../helpers/StorageManager";

const initialState = {
  authenticated: !!StorageManager.get("TOKEN"),
  user: null,
  authenticationError: null,
  loadingUser: true,
  loading: false,
  authenticateUser: false,
  role: null,
  sessionExpired: false,
};

export default initialState;
